module.exports = __webpack_public_path__ + "img/advertise-text.2a5830ca.svg";